/* eslint-disable @typescript-eslint/no-namespace */
import { OrderStatusV2Enum } from '@/enums/orderV2';
import type { CalcPlanList } from '../apply-product/types';

export namespace OrdersV2 {
  // 申请订单相关的渠道信息，只声明了需要使用的属性
  export interface CommodityDetail {
    commodityId: string | number;
    commodityName: string;
    /** 资方code */
    capitalCode: string;
    // 可能部分渠道未配置icon，研发需要考虑存在性
    icon?: string;
  }

  // 提现放款出资方
  export interface InvestorData {
    loanOrderId: string | number;
    name: string;
    rate: 0; // 出资占比
  }

  // 提现放款银行卡
  export interface LoanBankData {
    userId: string; // 用户ID
    bankCode: string; // 银行代码
    bankName: string; // 银行名称
    cardNo: string; // 银行卡卡号
    orderId: string; // 订单ID
    reservePhone: string; // 预留手机号码
  }

  // 提现订单信息
  export interface OrderDetail {
    state: OrderStatusV2Enum;
    lendFailedMsg?: string;
    investors: InvestorData[];
    applyAmount: string | number;
    loanUserBankInfo: LoanBankData;
    amount: string;
    loanOrderId: string; // 提现编号
    lentTime: string; // 提现时间
    period: string; // 还款期限-如12
    periodUnit: string; // 还款期限单位-如月
    repaymentModelName: '1' | '2' | '3'; // 还款方式
    couponName: string; // 优惠券名称
    loanUsage: string;
    planTrail?: CalcPlanList[];
    rateType?: 'YEAR' | 'MONTH' | 'DAY' | null;
    rateValue?: number;
    productId?: string;
    shouldPayAmount?: number;
    settleFeeRate: number; // 提前结清费用比例
    settleFeeMax: number; // 提前结清手续费最高金额
    allShouldAmountTrail?: number; // 还款试算总息费
    /** 资方code */
    capitalCode?: string;
    /** 标准错误码 */
    standardErrorCode?: string;
    /** 标准错误原因 */
    standardReason?: string;
    /** 标准错误建议 */
    standardSuggestion?: string;
    /** 支持结清证明开具 */
    payOffCertificate?: boolean;
    /** 是否显示顶部通知栏提示 */
    isStockUpReminder?: boolean;
    /** 顶部通知栏提示文案 */
    stockUpReminderText?: string;
  }
}

// 新增：f.loan.show.more.capital 接口出参类型
export interface MoreCapitalContract {
  url: string;
  name: string;
}

export interface MoreCapitalResItem {
  /** 产品id */
  productId: string;
  /** 资方名称 */
  productName?: string;
  /** 资方图标 */
  productIcon?: string;
  /** 资方code */
  capitalCode?: string;
  /** 协议列表 */
  contractList: MoreCapitalContract[];
}

export interface MoreCapitalRes {
  /** 是否展示互兜模块 */
  showPanel: boolean;
  /** 兜底资方code */
  moreCapitalCode: string;
  /** 资方列表 */
  contractResList: MoreCapitalResItem[];
}

export interface StuckContractRes {
  /** 资方列表 */
  contractResList: MoreCapitalResItem[];
  /** 提现申请金额 */
  loanApplyAmount: number;
  /** 提现申请期数 */
  loanApplyPeriod: number;
  /** 提现渠道id */
  productId: string;
  /** 提现渠道名称 */
  productName: string;
}

/** 计算场景枚举 */
export enum CalcSceneEnum {
  /** 卡单订单计算场景 */
  STUCK_ORDER = 'stuckOrder',
}
